import React, { useState, useEffect, useContext, useMemo, useRef } from 'react'
import { formatCurrency } from '../../../../../utils/formatter'
//import { OrganizationAPI } from '../../../../../../api/organization.api'
import CancelIcon from '@mui/icons-material/HighlightOffOutlined'
import AddIcon from '@mui/icons-material/AddCircleOutlineOutlined'
import { TextField } from '@mui/material'
import { cuentaAux, editLuca, usuarioLuca } from '../../../../data/dataComprobante'
import TablaAuxiliar from './TablaAuxiliar'
import GlobalContext from '../../../../../../context/global-context'
import { BusinessAPI } from '../../../../../../api/business.api'

const TablaNuevoComprobante = ({
  setTotalDebe,setTotalHaber,totalDebe,totalHaber,setLibros,glosaPrincipal,isRequired,setListaAuxiliar,
  context,initialData = [],isBorrador,validation, razonSocial,rut,nombreFolio,vencimiento,folio,createUserId,listaDataAuxiliar}) => {
  const [dataCuentas, setDataCuentas] = useState([])
  const [filteredCuentas, setFilteredCuentas] = useState([])
  const [rows, setRows] = useState([])
  const [activeRowIndex, setActiveRowIndex] = useState(null)
  const [activeField, setActiveField] = useState('')
  const cuentaSearchRefs = useRef({})
  //const organizationAPI = new OrganizationAPI()
  const businessAPI = new BusinessAPI()
  const [rowsWithAuxiliar, setRowsWithAuxiliar] = useState([])
  const { ui, currentBusiness } = useContext(GlobalContext)
  const isRowEnabled = codigo => {
    if (parseInt(validation) === 0) {
      if (createUserId === null) {
        return codigo.startsWith('3')
      } else {
        return true
      }
    }
    return true
  }

  const normalizarFila = row => ({
    searchTerm: row.searchTerm || '',
    glosa: row.glosa || '',
    glosaEditada: typeof row.glosaEditada === 'boolean' ? row.glosaEditada : false,
    debe: row.debe != null ? row.debe : '',
    haber: row.haber != null ? row.haber : '',
    cuentaContableId: row.cuentaContableId || null,
    isDisabled: row.isDisabled || false,
    isModified: row.isModified || false,
    codigo: row.codigo || '',
    name: row.name || ''
  })

  useEffect(() => {
    if (context === 'edit') {
      if (Array.isArray(initialData) && initialData.length > 0) {
        setRows(
          initialData.map(row => {
            const cuentaEncontrada = dataCuentas.find(cuenta => cuenta.id === row.cuentaContableId)
            return normalizarFila({
              ...row,
              searchTerm: `${row.codigo || cuentaEncontrada?.codigo || ''} - ${
                row.name || cuentaEncontrada?.name || ''
              }`,
              isDisabled: !isRowEnabled(row.codigo || cuentaEncontrada?.codigo || '')
            })
          })
        )
        const matchingIndexes = initialData.reduce((indexes, row, index) => {
          if (cuentaAux.includes(row.codigo)) {
            indexes.push(index)
          }
          return indexes
        }, [])
        setRowsWithAuxiliar(matchingIndexes)
      } else if (initialData.length === 0 && isBorrador && rows.length === 0) {
        setRows([
          { searchTerm: '', glosa: '', debe: '', haber: '' },
          { searchTerm: '', glosa: '', debe: '', haber: '' }
        ])
      }
    }
  }, [initialData, context, isBorrador, createUserId, validation, dataCuentas])

  useEffect(() => {
    if (context === 'nuevo') {
      setRows([normalizarFila({}), normalizarFila({})])
    }
  }, [context])

  const getCuentasPermitidas = (search = '') => {
    const searchLower = search.toLowerCase()

    const tieneDebeMayorCero = listaDataAuxiliar?.[0]?.debe > 0

    return dataCuentas.filter(cuenta => {
      const cumpleTexto =
        cuenta.codigo.toLowerCase().includes(searchLower) ||
        cuenta.name?.toLowerCase().includes(searchLower)

      if (!cumpleTexto) return false

      if (createUserId === null) {
        if (tieneDebeMayorCero) {
          return editLuca.includes(cuenta.codigo)
        }
        return usuarioLuca.includes(cuenta.codigo)
      }

      return true
    })
  }

  useEffect(() => {
    if (activeField !== 'searchTerm' || activeRowIndex == null) return undefined

    const handleClickOutside = event => {
      const activeContainer = cuentaSearchRefs.current[activeRowIndex]
      if (activeContainer && !activeContainer.contains(event.target)) {
        setActiveRowIndex(null)
        setActiveField('')
        setFilteredCuentas([])
      }
    }

    const handleEscape = event => {
      if (event.key === 'Escape') {
        setActiveRowIndex(null)
        setActiveField('')
        setFilteredCuentas([])
      }
    }

    document.addEventListener('mousedown', handleClickOutside)
    document.addEventListener('keydown', handleEscape)

    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
      document.removeEventListener('keydown', handleEscape)
    }
  }, [activeField, activeRowIndex])


  const handleCuentaInputChange = (index, value) => {
    const updatedRows = [...rows]
    updatedRows[index].searchTerm = value
    setRows(updatedRows)
    setLibros(updatedRows)

    const trimmedValue = value.trim()
    setFilteredCuentas(trimmedValue ? getCuentasPermitidas(value) : [])
    setActiveRowIndex(index)
    setActiveField('searchTerm')
  }



  const handleCuentaSelect = (index, cuenta) => {
    if (isRequired && (!cuenta.codigo || !cuenta.name)) {
      alert('La cuenta seleccionada es obligatoria.')
      return
    }
    const updatedRows = [...rows]
    updatedRows[index] = {
      ...updatedRows[index],
      name: cuenta.name,
      codigo: cuenta.codigo,
      cuentaContableId: cuenta.id,
      searchTerm: `${cuenta.codigo} - ${cuenta.name}`,
      isDisabled: !isRowEnabled(cuenta.codigo),
      isModified: true
    }
    setRows(updatedRows)
    setFilteredCuentas([])
    setActiveRowIndex(null)
    setActiveField('')
    setLibros(updatedRows)

    const isAux = cuentaAux.includes(cuenta.codigo.toString())
    setRowsWithAuxiliar(prev => (isAux ? [...prev, index] : prev.filter(i => i !== index)))
  }

  const handleDebeChange = (index, value) => {
    const updatedRows = [...rows]
    updatedRows[index].debe = value
    if (value) {
      updatedRows[index].haber = 0
    }
    setRows(updatedRows)
    setLibros(updatedRows)
  }

  const handleHaberChange = (index, value) => {
    const updatedRows = [...rows]
    updatedRows[index].haber = value
    if (value) {
      updatedRows[index].debe = 0
    }
    setRows(updatedRows)
    setLibros(updatedRows)
  }

  const functionGetData = async () => {
    try {
      ui.setLoader({ visible: true })
      const responseCuentas = await businessAPI.getCuentasUsadas({
        businessId: currentBusiness.id
      })
      setDataCuentas(responseCuentas.data)
    } catch (error) {
      console.error(error)
    } finally {
      ui.setLoader({ visible: false })
    }
  }

  useEffect(() => {
    functionGetData()
  }, [])

  useEffect(() => {
    // sólo filas con cuenta asignada
    const validRows = rows.filter(r => r.cuentaContableId)

    const newTotalDebe = validRows.reduce((sum, row) => sum + (parseFloat(row.debe) || 0), 0)
    const newTotalHaber = validRows.reduce((sum, row) => sum + (parseFloat(row.haber) || 0), 0)

    setTotalDebe(newTotalDebe)
    setTotalHaber(newTotalHaber)
  }, [rows, setTotalDebe, setTotalHaber])

  useEffect(() => {
    setLibros(rows)
  }, [rows])

  useEffect(() => {
    if (!Array.isArray(rows) || rows.length === 0) return

    const updatedRows = rows.map(row => {
      const fila = normalizarFila(row)
      if (!fila.glosaEditada) {
        return { ...fila, glosa: glosaPrincipal }
      }
      return fila
    })
    setRows(updatedRows)
  }, [glosaPrincipal])

  const hasInvalidRows = useMemo(
    () =>
      rows.some(
        r =>
          !r.cuentaContableId && ((parseFloat(r.debe) || 0) > 0 || (parseFloat(r.haber) || 0) > 0)
      ),
    [rows]
  )

  const handleAddRow = index => {
    if (!rows[index].cuentaContableId) return
    setRows([...rows, normalizarFila({})])
  }

  return (
    <div className='border rounded-lg p-4 mt-4 bg-gray-50 font-sans'>
      <table className='min-w-full table-fixed border-collapse text-xs text-left'>
        <thead>
          <tr className='p-2 text-center text-xs'>
            <th className='w-2/5'>Cuenta</th>
            <th className='w-1/8'>Debe</th>
            <th className='w-1/8'>Haber</th>
            <th className='w-1/5'>Glosa</th>
            <th className='w-1/8'></th>
          </tr>
        </thead>
        <tbody>
          {rows.map((row, index) => (
            <React.Fragment key={index}>
              <tr className='text-xs'>
                <td className='py-3 px-2 w-2/5'>
                  <div
                    className='relative'
                    ref={element => {
                      cuentaSearchRefs.current[index] = element
                    }}
                  >
                    <TextField
                      type='text'
                      placeholder='Buscar por código o nombre'
                      value={row.searchTerm || ''}
                      onChange={e => handleCuentaInputChange(index, e.target.value)}
                      className='rounded p-1 w-full text-[11px]'
                      variant='standard'
                      required={isRequired}
                      disabled={row.isDisabled}
                      onFocus={() => {
                        setActiveRowIndex(index)
                        setActiveField('searchTerm')
                        const searchValue = row.searchTerm?.trim() || ''
                        setFilteredCuentas(searchValue ? getCuentasPermitidas(searchValue) : [])
                      }}
                      InputProps={{
                        sx: {
                          fontSize: '12px', // Tamaño del input
                        },
                      }}
                      InputLabelProps={{
                        sx: {
                          fontSize: '12px', // Tamaño del label si tuviera
                        },
                      }}
                    />
                    {index === activeRowIndex &&
                      activeField === 'searchTerm' &&
                      filteredCuentas.length > 0 && (
                      <ul className='absolute z-10 bg-white border rounded w-full mt-1 max-h-60 overflow-auto'>
                        {filteredCuentas.map(cuenta => (
                          <li
                            key={cuenta.id}
                            className='text-[11px] cursor-pointer p-2 hover:bg-gray-200 ' 
                            onClick={() => handleCuentaSelect(index, cuenta)}
                          >
                            {cuenta.codigo} - {cuenta.name}
                          </li>
                        ))}
                      </ul>
                    )}
                  </div>
                </td>
                <td className='w-1/8 py-3 px-2'>
                  <TextField
                    name='debe'
                    value={row.debe}
                    onChange={e => handleDebeChange(index, e.target.value)}
                    className='rounded p-1 w-full'
                    variant='standard'
                    onBlur={() => {
                      if (row.debe === '') {
                        const upd = [...rows]
                        upd[index].debe = 0
                        setRows(upd)
                      }
                    }}
                    onKeyDown={e => {
                      if (['-', '+', '.', 'e'].includes(e.key)) {
                        e.preventDefault()
                      }
                    }}
                    required={isRequired}
                    disabled={row.isDisabled}
                    InputProps={{
                        sx: {
                          fontSize: '12px', // Tamaño del input
                        },
                      }}
                    InputLabelProps={{
                      sx: {
                        fontSize: '12px', // Tamaño del label si tuviera
                      },
                    }}
                  />
                </td>
                <td className='w-1/8 py-3 px-2'>
                  <TextField
                    name='haber'
                    value={row.haber}
                    onChange={e => handleHaberChange(index, e.target.value)}
                    className='rounded p-1 w-full'
                    variant='standard'
                    onBlur={() => {
                      if (row.haber === '') {
                        const upd = [...rows]
                        upd[index].debe = 0
                        setRows(upd)
                      }
                    }}
                    onKeyDown={e => {
                      if (['-', '+', '.', 'e'].includes(e.key)) {
                        e.preventDefault()
                      }
                    }}
                    required={isRequired}
                    disabled={row.isDisabled}
                    InputProps={{
                        sx: {
                          fontSize: '12px', // Tamaño del input
                        },
                      }}
                    InputLabelProps={{
                      sx: {
                        fontSize: '12px', // Tamaño del label si tuviera
                      },
                    }}
                  />
                </td>
                <td className='w-1/8 py-3 px-2'>
                  <TextField
                    name='glosa'
                    className='rounded p-1 w-full'
                    variant='standard'
                    value={row.glosa || ''}
                    onBlur={e => {
                      if (!e.target.value.trim()) {
                        const updatedRows = [...rows]
                        updatedRows[index].glosa = glosaPrincipal
                        updatedRows[index].glosaEditada = false
                        setRows(updatedRows)
                        setLibros(updatedRows)
                      }
                    }}
                    onChange={e => {
                      const updatedRows = [...rows]
                      updatedRows[index].glosa = e.target.value
                      updatedRows[index].glosaEditada = true
                      setRows(updatedRows)
                      setLibros(updatedRows)
                    }}
                    required={isRequired}
                    disabled={row.isDisabled}
                    InputProps={{
                        sx: {
                          fontSize: '12px', // Tamaño del input
                        },
                      }}
                    InputLabelProps={{
                      sx: {
                        fontSize: '12px', // Tamaño del label si tuviera
                      },
                    }}
                  />
                </td>
                <td className='flex items-center space-x-2 py-2 w-1/8'>
                  {index === rows.length - 1 && (
                    <button
                      onClick={() => handleAddRow(index)}
                      disabled={row.isDisabled || !row.cuentaContableId || hasInvalidRows}
                      title={
                        !row.cuentaContableId
                          ? 'Selecciona primero una cuenta'
                          : hasInvalidRows
                            ? 'Hay montos sin cuenta pendiente'
                            : ''
                      }
                    >
                      <AddIcon />
                    </button>
                  )}
                  {index >= 2 && (
                    <button
                      onClick={() => setRows(rows.filter((_, i) => i !== index))}
                      disabled={row.isDisabled}
                    >
                      <CancelIcon />
                    </button>
                  )}
                </td>
              </tr>
              {rowsWithAuxiliar.includes(index) && (
                <tr>
                  <td colSpan='5'>
                    <TablaAuxiliar
                      listaAuxiliar={rows[index].auxiliar || []}  
                      setListaAuxiliar={auxiliar => {
                        const updatedRows = [...rows]
                        updatedRows[index].auxiliar = auxiliar
                        setRows(updatedRows)
                        setLibros(updatedRows)
                        setListaAuxiliar(auxiliar)
                      }}
                      razonSocial={razonSocial}
                      rut={rut}
                      nombreFolio={nombreFolio}
                      vencimiento={vencimiento}
                      folio={folio}
                      createUserId={createUserId}
                      validation={validation}
                    />
                  </td>
                </tr>
              )}
            </React.Fragment>
          ))}
          <tr>
            <td colSpan='1' className='text-right font-bold py-2'>
              Total
            </td>
            <td className='font-bold py-2'>{formatCurrency(totalDebe)}</td>
            <td className='font-bold py-2'>{formatCurrency(totalHaber)}</td>
            <td className='w-1/8'></td>
          </tr>
        </tbody>
      </table>
    </div>
  )
}

export default TablaNuevoComprobante
